export default __webpack_public_path__ + "img/traithvg.fc1c043f.png";